enum SubSections {
  FactoryUpgrades = 'factory-upgrades',
  GreatDeal = 'great-deal',
  Incentives = 'incentives',
  NewPrice = 'new-price',
  OriginalPrice = 'original-price',
  Trade = 'trade',
  TradeIncentives = 'trade-incentives'
}

export default SubSections;
